import type { GetDashboardsResponse, GetSettingsResponse } from "@/types/openapi-ts";

/**
 * данный метод фильтрует метрики в dashboards (panels[]) которые не доступны данному пользователю в пермишеннах
 */
const filtredMetricIsNotAvailable = (
    stateDashboards: GetDashboardsResponse['payload'], 
  availebleColumns: GetSettingsResponse['payload']['reports']['metrics'][number]['column_name'][] = [], 
  availebleDimensions: GetSettingsResponse['payload']['reports']['dimensions'][number]['column_name'][] = [],
) => stateDashboards
  .map((dash) => {
    const filters = (dash?.filters as any)?.filters || { search: {} };
    /* globalfilter delete not supported  dimensions */
    const parseGlobalFilter = avaalibleDimensionFilterMethod(filters, availebleDimensions);
    /* ////// globalfilter delete not supported  dimensions */

    const rows = dash.rows
      .map((row) => {
        let panels = row.panels.filter((panelItem) => {
          const atLeastOneFalse = [];
          if ('metric_name' in panelItem) {
            atLeastOneFalse.push(availebleColumns.includes(panelItem.metric_name as typeof availebleColumns[number]));
            if (!atLeastOneFalse.every((el) => el)) return false;
          }
          if ('series_group_by_metric_name' in panelItem && panelItem.series_group_by_metric_name) {
            atLeastOneFalse.push(availebleColumns.includes(
              panelItem.series_group_by_metric_name as typeof availebleColumns[number]
            ));
            if (!atLeastOneFalse.every((el) => el)) return false;
          }
          if (
            'series_group_by_dimension_name' in panelItem 
            && panelItem && typeof (panelItem?.series_group_by_dimension_name) === 'string'
          ) {
            atLeastOneFalse.push(availebleDimensions.includes(
              panelItem.series_group_by_dimension_name as typeof availebleDimensions[number])
            );
            if (!atLeastOneFalse.every((el) => el)) return false;
          }
          if ('dimension_name' in panelItem && typeof (panelItem?.dimension_name) === 'string') {
            atLeastOneFalse.push(availebleDimensions.includes(
              panelItem.dimension_name as typeof availebleDimensions[number])
            );
            if (!atLeastOneFalse.every((el) => el)) return false;
          }

          return true;
        });

        panels = panels.map((panelItem) => {
          if (panelItem.type === 'chart') {
            if ('series' in panelItem && (panelItem.series as any[]).length) {
              let series = (panelItem.series  as any[]).filter((ser) => availebleColumns.includes(ser.metric_name));

              series = series.map((ser) => {
                if (ser.filters?.filters) {
                  const parseSeriesFilter = avaalibleDimensionFilterMethod(ser.filters.filters, availebleDimensions);
                  return { ...ser, filters: { ...ser.filters, filters: parseSeriesFilter } };
                }
                return ser;
              });

              return { ...panelItem, series: series.length ? series : null };
            }
          }
          return panelItem;
        });

        panels = panels.map((panelItem) => {
          if ((panelItem.filters as any)?.filters) {
            const parsePanelFilter = avaalibleDimensionFilterMethod(
              (panelItem.filters as any).filters, 
              availebleDimensions
            );
            return { ...panelItem, filters: { ...(panelItem.filters as any), filters: parsePanelFilter } };
          }
          return panelItem;
        });

        //@ts-expect-error panelItem.series может быть undefined, а undefined !== null
        panels = panels.filter((panelItem) => panelItem.series !== null);

        return { ...row, panels };
      })
      .filter((row) => row.panels.length !== 0);
    return { ...dash, filters: { ...(dash.filters as any), filters: parseGlobalFilter }, rows };
  })
  .filter((dash) => dash.rows.length !== 0);


function avaalibleDimensionFilterMethod(
  data: any, 
  availebleDimensions: GetSettingsResponse['payload']['reports']['dimensions'][number]['column_name'][]
) {
  const dataFilter = data || {};
  const keyFiltersDimensions = Object.keys(dataFilter);
  const filtersDimensions = dataFilter;
  const filtersDimensionsNew = keyFiltersDimensions.reduce((acc: any, keyFilter) => {
    if (availebleDimensions.includes(keyFilter as typeof availebleDimensions[number])) {
      acc[keyFilter] = filtersDimensions[keyFilter];
      return acc;
    }
    return acc;
  }, {});
  return filtersDimensionsNew;
}

export default filtredMetricIsNotAvailable;
